import React from 'react';
import { render } from 'react-dom';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import { provideHealthcheck } from '@atlassian/jira-common-healthcheck/src/utils/healthcheck-utils/index.tsx';
import { JiraContextContainer } from '@atlassian/jira-context-container/src/JiraContextContainer.tsx';
import { ProfileCardLegacy } from '@atlassian/jira-profilecard-next/src/ui/profilecard-legacy/index.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/StrictMode.tsx';

provideHealthcheck();

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const container = document.createElement('div');
container.id = 'profilecard-app';

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
document.body && document.body.appendChild(container);

render(
	<StrictMode>
		<JiraContextContainer>
			<AppBase id="profilecard-next">
				<ProfileCardLegacy />
			</AppBase>
		</JiraContextContainer>
	</StrictMode>,
	container,
);
